import { useState } from "react";
import { C } from "../data/constants";
import { useApi } from "../hooks/useApi";
import { scrollTo } from "../hooks/useScrollFade";

export default function BuildYourOwn() {
  const { data, loading } = useApi("/packages/byo");
  const byoItems = data?.data || {};
  const categories = Object.keys(byoItems);
  const [cat, setCat] = useState(null);
  const [selected, setSelected] = useState({});
  const activeCategory = cat || categories[0];

  const toggle = (catKey, item) => {
    const key = `${catKey}||${item.name}`;
    setSelected(prev => { const n = { ...prev }; if (n[key]) delete n[key]; else n[key] = { ...item, category: catKey }; return n; });
  };

  const selectedList = Object.values(selected);
  const itemsTotal = selectedList.reduce((sum, item) => sum + (item.value || 0), 0);
  const labourIncluded = selectedList.some(i => i.name === "Labour/transport base");
  const grandTotal = itemsTotal + (labourIncluded ? 0 : 300);

  return (
    <section id="build-your-own" className="section-pad" style={{ background: C.sand }}>
      <div className="container">
        <div className="section-header">
          <p style={{ color: C.slate, letterSpacing: 3, textTransform: "uppercase", fontSize: 11, marginBottom: 10 }}>Fully Customisable</p>
          <h2 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 300, color: C.dark, marginBottom: 14 }}>Build Your Own</h2>
          <div style={{ width: 48, height: 1, background: C.blush, margin: "0 auto 14px" }} />
          <p style={{ color: C.mid, maxWidth: 500, margin: "0 auto", lineHeight: 1.8, fontSize: "clamp(13px,1.5vw,15px)" }}>
            Pick exactly what you want — a R300 labour & transport base fee applies.
          </p>
        </div>

        {loading ? (
          <p style={{ textAlign: "center", color: C.slate, fontStyle: "italic" }}>Loading options…</p>
        ) : (
          <div className="byo-layout">
            {/* Left */}
            <div>
              <div className="tabs-scroll" style={{ marginBottom: 20 }}>
                {categories.map(c => (
                  <button key={c} className={`pkg-tab ${activeCategory === c ? "active" : "inactive"}`} onClick={() => setCat(c)}>{c}</button>
                ))}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {(byoItems[activeCategory] || []).map((item, i) => {
                  const key = `${activeCategory}||${item.name}`;
                  const isSel = !!selected[key];
                  return (
                    <button key={i} className={`addontag ${isSel ? "sel" : ""}`} onClick={() => toggle(activeCategory, item)}>
                      {isSel ? "✓ " : ""}{item.name} <strong style={{ marginLeft: 4 }}>{item.price}</strong>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Cart */}
            <div style={{ background: C.white, borderRadius: 18, padding: "24px 22px", position: "sticky", top: 72, boxShadow: "0 6px 28px rgba(44,40,38,0.1)" }}>
              <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: C.dark, marginBottom: 14 }}>Your Selection</h3>
              {selectedList.length === 0 ? (
                <p style={{ color: C.slate, fontSize: 13, fontStyle: "italic" }}>No items yet — tap items on the left.</p>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, marginBottom: 14, maxHeight: 280, overflowY: "auto" }}>
                  {selectedList.map((item, i) => (
                    <li key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${C.linen}`, fontSize: 13, color: C.mid }}>
                      <span style={{ flex: 1, marginRight: 8, fontSize: 12 }}>{item.name}</span>
                      <span style={{ color: C.blush, fontWeight: 500, flexShrink: 0 }}>{item.price}</span>
                      <button onClick={() => toggle(item.category, item)} style={{ background: "none", border: "none", color: C.slate, cursor: "pointer", fontSize: 15, marginLeft: 6 }}>×</button>
                    </li>
                  ))}
                  {!labourIncluded && (
                    <li style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 12, color: C.slate, fontStyle: "italic" }}>
                      <span>Labour & transport base</span><span>R300</span>
                    </li>
                  )}
                </ul>
              )}
              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0 0", borderTop: `2px solid ${C.blush}` }}>
                <strong style={{ color: C.dark, fontSize: 14 }}>Est. Total</strong>
                <strong style={{ color: C.blush, fontSize: 20 }}>R{grandTotal.toLocaleString()}</strong>
              </div>
              <p style={{ fontSize: 11, color: C.slate, marginTop: 5, fontStyle: "italic" }}>Estimates only. Contact us for final quote.</p>
              <button onClick={() => { sessionStorage.setItem("byoPayload", JSON.stringify({ eventType: "Custom / Build Your Own", customItems: selectedList.map(i => ({ name: i.name, price: i.price })), estimatedTotal: `R${grandTotal.toLocaleString()}` })); scrollTo("contact"); }}
                style={{ width: "100%", background: C.blush, color: C.white, border: "none", padding: "11px", borderRadius: 22, fontSize: 14, cursor: "pointer", marginTop: 14 }}>
                Get My Custom Quote 
              </button>
              {selectedList.length > 0 && (
                <button onClick={() => setSelected({})}
                  style={{ width: "100%", background: "none", border: `1px solid ${C.sand}`, color: C.slate, padding: "8px", borderRadius: 22, fontSize: 13, cursor: "pointer", marginTop: 8 }}>
                  Clear Selection
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}